import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import * as $ from 'jquery';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q12',
  templateUrl: './r-q12.component.html',
  styleUrls: ['./r-q12.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ12Component implements OnInit {

  @Input() data: any;
  isDisable;
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  bedrooms = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '10+'];
  bathrooms = ['1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6+'];
  bed_rooms;
  bath_rooms;
  property;
  rent_own;
  messagetype;
  deviceWidth;
  user_bot;
  time = 2000;
  showTyping = false;
  showbutton = true;
  timer;
  typingTimer;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.property = this.residentialService.property;
    // this.bath_rooms = this.bathrooms[0];
    // this.bed_rooms = this.bedrooms[0];
    this.deviceWidth = this.residentialService.deviceWidth;
    this.rent_own = this.residentialService.rent_own;
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ 'nextId': '0014' });
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    if (!_.isEmpty(this.property)) {
      if (this.property === 'Apartment or condominium') {
        this.question = this.question.replace('home', 'apartment');
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.bed_rooms = obj.fieldValue.bed_rooms;
        this.bath_rooms = obj.fieldValue.bath_rooms;
        if (!_.isEmpty(this.bed_rooms) && !_.isEmpty(this.bath_rooms)) {
          this.user_bot =  true;
          if (this.deviceWidth < 768) {
            this.showTyping = true;
            setTimeout(() => {
              this.showTyping = false;
              this.next();
            }, this.time);
          }
        }
        // if (this.deviceWidth < 768) {
        //   this.next();
        // }
      }
    }
    this.messagetype = this.residentialService.messervicetype;

    
    if (_.isEmpty(this.bed_rooms) && _.isEmpty(this.bath_rooms))
    {
      this.showbutton = false;
    }

    if(this.deviceWidth < 768)
    {
      setTimeout(function(){

        $('ng-select:visible').find('.ng-input').find('input').on('focus', function() { $(this).blur(); });
  
      },500)
    }


    
  }

  getBedrooms(event) {
    this.bed_rooms = event;
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({'currentId': this.data});
    }
    this.time  = 2000;
    if (!_.isEmpty(this.bed_rooms) && !_.isEmpty(this.bath_rooms)) {
      this.user_bot = true;
      this.save();
      this.goNext();

      if (this.deviceWidth < 768) {
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
      }
    }
  }

  getBathrooms(event) {
    this.bath_rooms = event;
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({'currentId': this.data});
    }
    this.time  = 2000;
    if (!_.isEmpty(this.bed_rooms) && !_.isEmpty(this.bath_rooms)) {
      this.user_bot = true;
      this.save();
      this.goNext();
      
      if (this.deviceWidth < 768) {
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
      }
    }

    
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.timer = setTimeout(() => {
        // // console.log.log(this.time);
        this.showTyping = false;
        this.next();
      }, 0);
    }
  }

  next() {
    if (this.bed_rooms === '' || this.bed_rooms === null || this.bed_rooms === undefined ||
      this.bath_rooms === '' || this.bath_rooms === null || this.bath_rooms === undefined) {
      // console.log.log('bed:', this.bed_rooms, 'bath:', this.bath_rooms);
    } else {
      this.save();
      this.user_bot = true;
      if (this.rent_own === 'Rent') {
        this.residentialService.messageService({ 'currentId': this.data, 'nextId': '0014' });
      } else {
        this.residentialService.messageService({ 'currentId': this.data });
      }
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data,
      'fieldName': 'floor_plan',
      'fieldValue': { 'bed_rooms': this.bed_rooms, 'bath_rooms': this.bath_rooms }
    };
    this.residentialService.updateResponses(Obj);
  }

  onOpen(event) {
    $("#"+ event).find('.ng-input').find('input').attr('readonly','readonly')
  
  }
  onOpen2() {
    
    setTimeout(() => {
      const scrollContainer = document.querySelector('.ng-dropdown-panel-items');
      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      }
    }, 0);
  }
  
  
}



